module.exports = "<h1 mat-dialog-title>New item</h1>\n<div mat-dialog-content>\n\t<mat-input-container>\n\t\t<input matInput placeholder=\"Name\" [(ngModel)]=\"itemName\">\n\t</mat-input-container>\n</div>\n\n<div mat-dialog-actions>\n\t<button mat-button (click)=\"cancel()\">CANCEL</button>\n\t<button mat-raised-button (click)=\"create()\" [disabled]=\"!itemName\" color=\"primary\">CREATE</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/manager/new-item.dialog.html
// module id = ../../../../../src/app/manager/new-item.dialog.html
// module chunks = main